import { render } from "./PaiementPaypalPage.vue?vue&type=template&id=1bbf61c4&ts=true"
import script from "./PaiementPaypalPage.vue?vue&type=script&lang=ts"
export * from "./PaiementPaypalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__